module.exports = new __parcel__URL__("right_section_bg_light.524451d7.svg").toString();